import { useAuth } from "@/auth/AuthProvider";
import { Button } from "../ui/button";
import { Lock } from "lucide-react";

export const AccessDenied = () => {
  const { user } = useAuth();
  const canView = user?.permissions?.view_all_projects === true;

  if (canView) {
    return null;
  }

  return (
    <div className="flex items-center justify-center p-4">
      <div className="w-full max-w-md text-center">
        <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-red-100">
          <Lock className="h-8 w-8 text-red-600" />
        </div>

        <h1 className="mt-6 text-3xl font-bold text-slate-900">
          Access Denied
        </h1>

        <p className="mt-4 text-lg text-slate-600">
          You do not have permission to view this project, or it may not exist.
        </p>

        <div className="mt-8">
          <Button className="bg-primary-blue px-6 py-3 text-base">
            <a href="/dashboard">Return to Dashboard</a>
          </Button>
        </div>
      </div>
    </div>
  );
};
